import React from "react";
import styled from "styled-components";

export default function OrderConfirmTitle() {
  return <Title>결제 완료! 👍🏻</Title>;
}

const Title = styled.h1`
  font-size: calc(100vw * (24 / 375));
  font-weight: 700;
  color: #000000;
  margin-bottom: calc(100vw * (25 / 375));
`;
